import douglasImage from '../assets/crew/image-douglas-hurley.webp';
import markImage from '../assets/crew/image-mark-shuttleworth.webp';
import VictorImage from '../assets/crew/image-victor-glover.webp';
import anoushehImage from '../assets/crew/image-anousheh-ansari.webp';
import '../style/crew.css';
import { useState } from 'react';

export default function Crew(){
    const listData = [
        {
            profession: 'COMMANDER',
            name: 'DOUGLAS HURLEY',
            paragraph:`Douglas Gerald Hurley is an American engineer,
            former Marine Corps pilot and former NASA astronaut. He
            launched into space for the third time as commander of
            Crew Dragon Demo-2.`,
            key:1,
            src: douglasImage,
        },
        {
            profession: 'MISSION SPECIALIST',
            name: 'MARK SHUTTLEWORTH',
            paragraph:`Mark Richard Shuttleworth is the founder and 
            CEO of Canonical, the company behind the Linux-based Ubuntu
            operating system. Shuttleworth became the first South African
            to travel to space as a space tourist.`,
            key:2,
            src: markImage,
        },
        {
            profession: 'PILOT',
            name: 'VICTOR GLOVER',
            paragraph:`Pilot on the first operational flight of the SpaceX
            Crew Dragon to the International Space Station. Glover is a
            commander in the U.S. Navy where he pilots an F/A-18.He was a
            crew member of Expedition 64, and served as a station systems flight engineer. `,
            key:3,
            src: VictorImage,
        },
        {
            profession: 'FLIGHT ENGINEER',
            name: 'ANOUSHEH ANSARI',
            paragraph:`Anousheh Ansari is an Iranian American engineer and
            co-founder of Prodea Systems. Ansari was the fourth self-funded
            space tourist, the first self-funded woman to fly to the ISS, and
            the first Iranian in space. `,
            key:4,
            src: anoushehImage,
        },
    ]

    const [currentCrew, setCurrentCrew] = useState('DOUGLAS HURLEY');
    const [data, setData] = useState(listData[0]);

    function navigationImageCrew(crewName){
        setCurrentCrew(crewName)
        if(crewName === 'DOUGLAS HURLEY'){
            setData(listData[0])
        }else if(crewName === 'MARK SHUTTLEWORTH'){
            setData(listData[1])
        }else if(crewName === 'VICTOR GLOVER'){
            setData(listData[2])
        }else{
            setData(listData[3])
        }
    }

    return (
        <div className="crew">
            <div className="crew-left">
                <div className='title'>
                    <span>02</span>
                    <p>MEET YOUR CREW</p>
                </div>

                <div className='text-destination'>
                    <h3>{data.profession}</h3>
                    <div>
                        {listData.map((list) =>  {
                            return <h1 className={currentCrew !== list.name ? 'non-active-title' : ''}
                            key={list.key}>{list.name}</h1>
                        })}
                    </div>
                    <p>{data.paragraph}</p>
                </div>

                <ul className='nav-crew'>
                    {listData.map((list) => {
                        return <li className={currentCrew === list.name ? 'activeNavCrew' : ''}
                        key={list.key} onClick={navigationImageCrew.bind(this, list.name)}>
                        </li>
                    })}
                </ul>
            </div>

            <div className='img-crew'>
                <div className='title'>
                    <span>02</span>
                    <p>MEET YOUR CREW</p>
                </div>

                <div>
                    {listData.map((data) => {
                        return <img className={currentCrew === data.name ? 'current-img' : 'non-active'}
                        src={data.src} alt={data.name + 'image'} key={data.key}/>
                    })}
                </div>
                
            </div>
        </div>
    )
}